import { __ } from "@wordpress/i18n";
import { useContext } from "react";
import { SettingsContext } from "../../Settings";

const CustomCodeSection = () => {
  const { register, settings } = useContext(SettingsContext);

  return (
    <>
      <div className="sb-tab-box sb-reset-box-style clearfix">
        <h3>{__("Custom Code", "feeds-for-youtube")}</h3>
      </div>
      <div className="sb-tab-box sb-custom-css-box sb-reset-box-style clearfix">
        <div className="tab-label">
          <h3>{__("Custom CSS", "feeds-for-youtube")}</h3>
        </div>
        <div className="sby-tab-form-field">
          <div className="sb-form-field">
            <div className="d-flex mb-15">
              <textarea
                {...register("custom_css")}
                defaultValue={settings.custom_css}
                className="sby-textarea"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="sb-tab-box sb-custom-js-box clearfix">
        <div className="tab-label">
          <h3>{__("Custom JavaScript", "feeds-for-youtube")}</h3>
        </div>
        <div className="sby-tab-form-field">
          <div className="sb-form-field">
            <div className="d-flex mb-15">
              <textarea
                {...register("custom_js")}
                defaultValue={settings.custom_js}
                className="sby-textarea"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomCodeSection;
